import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const labelStyles = {
  fontWeight: "bold",
  color: "#0A4986",
  fontSize: "14px",
};

export const MapContainerSection = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 4px 4px 0 rgb(0 0 0 / 25%);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const MapContainerOuter = styled.div`
  position: relative;
  margin: 0 1.375rem;
  height: 100%;
`;

export const MainTitle = styled.h2`
  width: 100%;
  text-align: center;
  font-family: "Lato";
  font-size: 22px;
  line-height: 22px;
  margin: 0 0 30px 0;
  color: #ff5200;
  text-transform: capitalize;
  font-weight: bold;
`;

export const MapContainer = styled.div`
  border-radius: 4px;
  position: relative;
  height: ${(props) => props.height ?? "100%"};
  overflow: hidden;
  outline: none;
  box-shadow: 0px 4px 4px rgba(63, 56, 56, 0.25);
  width: auto;
  border: solid 1px #00aeea;
  margin-bottom: 10px;
  margin-top: ${(props) => props.marginTop ?? "0px"};
`;

export const FilterOuter = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  height: auto;
  background: #fff
  backdrop-filter: blur(5px) grayscale(50%); /* CSS Filter on the overlay content */
  transition: opacity 0.3s ease, visibility 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #767676;
  margin-top: 10px;
  margin-left: 1px;
`;

export const FilterTitle = styled.div`
  justify-self: auto;
  color: ${(props) => props.color ?? "#767676"};
  font-size: 16px;
  font-weight: 700;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
  margin-bottom: ${(props) =>
    props?.marginBottom ? props.marginBottom : "10px"};
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
  font-size: 14px;
  width: 100%;
`;

export const FitlerOuterDiv = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-box-align: start;
  align-items: start;
  border: 1px solid #cccccc;
  background: #fff;
  padding: 10px;
  z-index: 999999999999;
  border-radius: 5px;
  box-shadow: ${(props) =>
    props.boxShadow ?? "2px 2px 4px 1px rgba(0, 76, 127, 0.25)"};
`;

export const FitlerInnerDiv = styled.div`
  max-height: 35rem;
  overflow-y: scroll;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
`;

export const Title = styled.h2`
  color: ${(props) => props?.color ?? "#00aeea"};
  font-size: 15px;
  font-family: lato;
  text-transform: initial;
  padding-top: 10px
  line-height: 1;
  margin: 0px;
  font-weight: bold !important;
  justify-self: auto;
`;

export const FilterContainer = styled.div`
  border-radius: 6px;
  outline: none;
  box-shadow: 0px 4px 4px rgba(63, 56, 56, 0.25);
  width: auto;
  border: solid 1px #cccccc;
  background: #c6edfb;
  padding: 5px;
`;

export const ContainerLabel = styled.label`
  width: auto;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 1;
  color: #0a4986;
  text-align: center;
  text-align: left;
  margin-top: ${(props) => (props?.marginTop ? props.marginTop : "0px")};
  margin-bottom: ${(props) =>
    props?.marginBottom ? props.marginBottom : "0px"};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  width: 100%;
`;

export const BorderImage = styled.div`
  padding: 5px;
  border: ${(props) => props.border ?? "solid 0px #fff"};
  border-radius: 5px;
  margin-right: 5px;
`;

export const GridLoaderItem = styled.div`
  text-align: center;
`;
